import styled from "styled-components";

export const BackgroundStyleToggle = styled.button<{ $active: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: var(--space-tight-padding);
    min-height: 40px;
    padding: 0 var(--space-card-padding);
    border-radius: var(--radius-sm, 8px);
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    background: ${(props) => (props.$active ? props.theme.palette.accent.dark : "transparent")};
    border: 1px solid ${(props) => props.theme.palette.accent.dark};
    color: ${(props) => (props.$active ? props.theme.palette.white : props.theme.palette.accent.dark)};

    &:hover {
        background: ${(props) => props.theme.palette.accent.light};
        border-color: ${(props) => props.theme.palette.accent.light};
        color: ${(props) => props.theme.palette.white};
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }

    &:active {
        transform: scale(0.98);
    }
`;